type ConsoleLogger = (message?: unknown, ...optionalParams: unknown[]) => void;

export declare enum LogLevel {
	TRACE = "trace",
	DEBUG = "debug",
	INFO = "info",
	WARN = "warn",
	ERROR = "error",
}

type Logger = Record<LogLevel, ConsoleLogger>;

export const getLogger = (prefix?: string): Logger => ({
	trace: (message, ...optionalParams) => console.trace(prefix, message, ...optionalParams),
	debug: (message, ...optionalParams) => console.debug(prefix, message, ...optionalParams),
	info: (message, ...optionalParams) => console.info(prefix, message, ...optionalParams),
	warn: (message, ...optionalParams) => console.warn(prefix, message, ...optionalParams),
	error: (message, ...optionalParams) => console.error(prefix, message, ...optionalParams),
});
